<template>
    <DashboardContentLayout class="space-y-8" :heading="$t('views.feed.reconciliations.header.heading')" :has-pig-type-picker="true" :has-period-picker="true">
        <Separator />
        <div class="space-y-6">
            <MainViewCard>
                <FeedReconciliationTable></FeedReconciliationTable>
            </MainViewCard>
        </div>
    </DashboardContentLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import DashboardContentLayout from '@/components/layouts/dashboardLayout/content/DashboardContentLayout.vue';
import MainViewCard from '@/components/common/MainViewCard.vue';
import Separator from '@/components/ui/separator/Separator.vue';
import FeedReconciliationTable from '@/views/dashboard/feed/feedReconciliations/FeedReconciliationTable.vue';

export default defineComponent({
    components: { DashboardContentLayout, MainViewCard, Separator, FeedReconciliationTable },
});
</script>
